import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';

const trackFeedbackBannerEvent = (eventName: string, additionalData: Record<string, unknown> = {}) => {
    const debugConfig = createDebugConfig();

    trackCustomEvent(
        eventName,
        {
            flow_name: 'feedback_banner',
            ...additionalData,
        },
        debugConfig
    );
};

export const trackFeedbackBannerClose = () => {
    trackFeedbackBannerEvent('feedback_banner_close', {
        trigger: 'click',
        element_name: 'close_button',
    });
};
